import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import ArchivesLink from '../../common/archives_link';
import Breadcrumbs from '../../article/breadcrumbs';
import OtherContributors from '../../article/other_contributors';

const EpisodeMeta = ({
  article: {
    breadcrumbs,
    bylines,
    original_published
  },
  metaTitle
}) => (
  <div className="meta">
    <span dangerouslySetInnerHTML={{ __html: metaTitle }} />
    <OtherContributors bylines={bylines} />
    <Breadcrumbs breadcrumbs={breadcrumbs} />
    <RosettaFormattedMessage parentFilename={__filename}
      id="release_date"
      description="Text denoting the date on which a video was rleased"
      defaultMessage="Released on {date}"
      values={{
        date:
          <ArchivesLink
            format="date"
            timestamp={original_published * 1000}
            eventLabel="original publish date"
          />
      }}
    />
  </div>
);

EpisodeMeta.propTypes = {
  article: PropTypes.shape({
    breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
    bylines: PropTypes.arrayOf(PropTypes.object).isRequired,
    original_published: PropTypes.number.isRequired
  }).isRequired,
  metaTitle: PropTypes.string.isRequired
};

export default EpisodeMeta;
